import { render, staticRenderFns } from "./CatalogOrders.vue?vue&type=template&id=61a75564"
import script from "./CatalogOrders.vue?vue&type=script&lang=js"
export * from "./CatalogOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports